import { FunctionComponent, useState, useEffect } from 'react';
import * as vp from 'vopay';
import styles from './AccountOverviewContainer.module.scss';
import DonutContainer from '../Donut/DonutContainer';
import AccountOverviewProgressTable from './AccountOverviewProgressTable';
import useFetchAccountsOverviewActive from '../../../../hooks/useApi/useFetchAccountsOverviewActive';
import usefetchUserDataOverview from '../../../../hooks/useApi/usefetchUserDataOverview';
import { useTranslation } from 'react-i18next';

const { Tabs, NoData, Box, SubTitle } = vp;

type TabContents = {
  Active: React.JSX.Element;
  InProgress: React.JSX.Element;
};

type FC = FunctionComponent;

const AccountOverviewContainer: FC = () => {
  const [activeTab, setActiveTab] = useState<keyof TabContents>('Active');
  const [accountsData, fetchAccountsOverviewActive] = useFetchAccountsOverviewActive({});
  const [userData, fetchUserDataOverview] = usefetchUserDataOverview({});
  const { t } = useTranslation('translations', { keyPrefix: 'HomePage.AccountOverviewWidget' });

  const monthlyData = Object.values(accountsData.Statistics || {})
    .map((data) => data.numOfData)
    .map((period) => Number(period.monthly))
    .reduce((res, num) => res + num, 0);
  const yearlyData = Object.values(accountsData.Statistics || {})
    .map((data) => data.numOfData)
    .map((period) => Number(period.yearly))
    .reduce((res, num) => res + num, 0);
  const weeklyData = Object.values(accountsData.Statistics || {})
    .map((data) => data.numOfData)
    .map((period) => Number(period.weekly))
    .reduce((res, num) => res + num, 0);

  const isNonZero = monthlyData + yearlyData + weeklyData > 0;

  useEffect(() => {
    fetchAccountsOverviewActive();
    fetchUserDataOverview();
  }, []);

  const handleTabClick = (tab: keyof TabContents) => {
    setActiveTab(tab);
  };

  return (
    <div className={styles.container}>
      <SubTitle subTitle={t('title')} variant="bold" />
      <Box flx="col" mt="md" gap="sm">
        <Tabs
          variant="chart"
          tabs={[
            {
              label: t('ActiveTab.tab'),
              onClick: () => handleTabClick('Active'),
            },
            {
              label: t('InProgressTab.tab'),
              onClick: () => handleTabClick('InProgress'),
            },
          ]}
        />

        {activeTab === 'Active' &&
          (accountsData.Statistics && isNonZero ? <DonutContainer accountsData={accountsData} /> : <NoData />)}
        {activeTab === 'InProgress' && (
          <div className={styles.progressContainer}>
            {userData.Statistics ? <AccountOverviewProgressTable userData={userData} /> : <NoData />}
          </div>
        )}
      </Box>
    </div>
  );
};

export default AccountOverviewContainer;
